import MultiSelectDropdown from 'components/MultiSelectDropdown';
import { useAtomValue } from 'jotai';
import callApi from 'lib/callApi';
import React, { useEffect, useState } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { companyIdAtom } from 'views/state';

const BranchSelector = ({ accountId, repoData, onBranchSelection }) => {
  const companyId = useAtomValue(companyIdAtom);
  const [branches, setBranches] = useState<any[]>();

  useEffect(() => {
    if (repoData && !branches) {
      // repositories/fetch-branches/
      const fetchData = async () => {
        const urlParams = {
          company_id: companyId,
          account_id: accountId,
          branches_url: repoData['branches_url'],
        };

        const response = await callApi(
          'sast/repositories/fetch-branches/',
          'GET',
          urlParams,
        );

        repoData['branches'] = response?.data;
        setBranches(filteredBranches(repoData));
      };

      if (accountId && repoData) {
        if (repoData['branches']) {
          setBranches(filteredBranches(repoData));
        } else {
          fetchData();
        }
      }
    }
  }, [repoData]);

  const filteredBranches = (repoData) => {
    if (repoData) {
      const allBranches = repoData['branches'];
      const connectedBranches = repoData['connected_branches'];
      return allBranches?.filter(
        (branch) => !connectedBranches.includes(branch.name),
      );
    }
  };

  const handleBranchSelection = (selectedOptions) => {
    repoData['new_branches'] = selectedOptions?.map((item) => ({
      id: item.value,
      name: item.label,
    }));
    // repoData['new_branches'] = selectedOptions;
    // console.log('selectedOptions', repoData['new_branches']);
    onBranchSelection();
  };

  if (!repoData) {
    return <div>&#123; Select repository &#125;</div>;
  }

  if (branches) {
    return (
      <div>
        <MultiSelectDropdown
          options={branches.map((branch) => ({
            value: branch.id,
            label: branch.name,
          }))}
          onSelectionChange={handleBranchSelection}
          placeholderText="select branches..."
        />
      </div>
    );
  }

  return (
    <div>
      <CircleSpinner size={20} color="#0665a9" loading={true} />
    </div>
  );
};

export default BranchSelector;
